// src/sagas/commissionPlanSlice.js

import { call, put } from "redux-saga/effects";
import { createModule } from "saga-slice";
import { commissionPlanService } from "../services/commissionPlanService";

const initial = {
  list: [],
  loading: false
};
const commissionPlanSlice = createModule({
  name: "commissionPlans",
  initialState: initial,
  reducers: {
    list: (s, _a) => {
      s.loading = true;
    },
    listSuccess: (s, payload) => {
      console.log("Reducer payload:", payload);
      s.loading = false;
      s.list = payload || [];
    },
    listFailure: (s) => {
      s.loading = false;
    },

    create: (s, _a) => {
      s.loading = true;
    },
    update: (s, _a) => {
      s.loading = true;
    },
    delete: (s, _a) => {
      s.loading = true;
    },

    mutateSuccess: (s) => { s.loading = false; },
    mutateFailure: (s) => { s.loading = false; },

  },
  sagas: (A) => ({
    *[A.list]({ payload }) {
      try {
        console.log("Saga payload:", payload);
        const { data } = yield call(commissionPlanService.list, payload);
        console.log("Saga data:", data);
        yield put(A.listSuccess(data));
      } catch {
        yield put(A.listFailure());
      }
    },
    *[A.create]({ payload }) {
      const { data, onSuccess, onError } = payload;
      try {
        const res = yield call(commissionPlanService.create, data);
        yield put(A.mutateSuccess());
        yield put(A.list({}));
        onSuccess?.(res.data);
      } catch (e) {
        yield put(A.mutateFailure());
        onError?.(e?.response?.data?.message || e.message);
      }
    },
    *[A.update]({ payload }) {
      const { data, onSuccess, onError } = payload;
      try {
        const res = yield call(commissionPlanService.update, data);
        yield put(A.mutateSuccess());
        yield put(A.list({}));
        onSuccess?.(res.data);
      } catch (e) {
        yield put(A.mutateFailure());
        onError?.(e?.response?.data?.message || e.message);
      }
    },
    *[A.delete]({ payload }) {
      const { id, onSuccess, onError } = payload;
      try {
        yield call(commissionPlanService.delete, { id });
        yield put(A.mutateSuccess());
        yield put(A.list({}));
        onSuccess?.();
      } catch (e) {
        yield put(A.mutateFailure());
        onError?.(e?.response?.data?.message || e.message);
      }
    },
  }),
});

export const commissionPlanActions = commissionPlanSlice.actions;
export default commissionPlanSlice;
